import React from "react";

const RadioGroup = (props) => {
  const {
    controleId,
    comp,
    stateData: data,
    stateErrors: errors,
    isDisabled,
    handeOnChange,
  } = props;

  const selectedValue = String(data[controleId] ?? "");
  const radioOptions = Array.isArray(comp.radioValues) ? comp.radioValues : [];

  return (
    <div className={`form-group ${comp.isRequired ? "required" : ""} ${comp?.cssclass || ""}`} style={{ marginBottom: "16px" }}>
      {comp.label && (
        <label className="form-control-label" style={{
          fontSize: "11px",
          fontWeight: 700,
          color: "#64748b",
          textTransform: "uppercase",
          letterSpacing: "0.7px",
          marginBottom: "10px",
          display: "block"
        }}>
          {comp.label}
        </label>
      )}

      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px 22px", alignItems: "center" }}>
        {radioOptions.map((item, key) => {
          const inputId = `${controleId}${key}`;
          const itemValue = item.value ?? item.name ?? "";
          const isChecked = selectedValue === String(itemValue);

          return (
            <label
              key={inputId}
              htmlFor={inputId}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "9px",
                minHeight: "32px",
                margin: 0,
                color: "#334155",
                cursor: isDisabled ? "not-allowed" : "pointer",
                fontFamily: "Inter, Roboto, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: 1.2,
                opacity: isDisabled ? 0.68 : 1,
                userSelect: "none"
              }}
            >
              <input
                type="radio"
                id={inputId}
                name={controleId}
                value={itemValue}
                checked={isChecked}
                onChange={handeOnChange}
                disabled={isDisabled}
                style={{
                  position: "absolute",
                  opacity: 0,
                  pointerEvents: "none"
                }}
              />
              <span
                aria-hidden="true"
                style={{
                  width: "18px",
                  height: "18px",
                  borderRadius: "50%",
                  border: isChecked ? "5px solid #2b62a1" : "1.5px solid #cbd5e1",
                  backgroundColor: "#ffffff",
                  boxShadow: isChecked ? "0 0 0 3px rgba(43, 98, 161, 0.12)" : "inset 0 0 0 3px #f8fafc",
                  boxSizing: "border-box",
                  flex: "0 0 18px",
                  transition: "border-color 0.15s ease, border-width 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease"
                }}
              />
              <span>
                {item.name}
              </span>
            </label>
          );
        })}
      </div>

      {errors[controleId] && (
        <div className="alert alert-danger" style={{ marginTop: 8, padding: "5px 10px", fontSize: "11.5px", borderRadius: "7px", display: "inline-block" }}>
          {errors[controleId]}
        </div>
      )}
    </div>
  );
}

export default RadioGroup;
